import { Button, Card, CardActions, CardContent, Typography } from '@mui/material'
import React, { useState } from 'react'
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import EditDialog from '../Modals/EditAddressDialog';
import ConfirmDialog from '../Modals/ConfirmDialog';
import { useDeleteAddressMutation, useUpdateAddressMutation } from '../../features/fullApi';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { toast } from 'react-hot-toast';

const Address = ({address}) => {

    const [openEdit, setOpenEdit] = useState(false)
    const [open, setOpen] = useState(false)
    const user = JSON.parse(localStorage.getItem('user'))

    const openModalEditItem = ((address) => {
        setOpenEdit(true)
    })

    console.log("###ADDRESS###", address)

    const handleDelete = ((addressId) => {
      setOpen(false)
      console.log("address id is", addressId)
      deleteAddress({id: addressId}, { 
        headers: {
          'Token': `Bearer ${user?.accessToken}`
        }
      })
      toast.success("Product successfully deleted")
    })

      console.log("Address###", address)

      console.log("###OPEN EDIT###", openEdit)

      const editItemMessage = "You are updating this item"
  
      const [updateAddress] = useUpdateAddressMutation()
      const [deleteAddress] = useDeleteAddressMutation()

    
      const message = "Are you sure you want to delete this address ?";
    
      const openDeleteModal = (() => {
        setOpen(true)
      })
    
      const handleUpdateAddress = ((brand) => {
        setOpenEdit(false)
        updateAddress({_id: brand.id._id, brandName: brand.brandName}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        }).then(
        )
      })
    

  return (
    <>
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Card sx={{display:'flex', justifyContent:'space-between', width:'100%', height:'100%'}}>
              <CardContent>
                <LocationOnIcon style={{fontSize:"40px"}} color="primary"/>
              </CardContent>
              <div style={{width:'300px'}}>
                <CardContent>
                  <Typography sx={{ fontSize: 14 }} variant="subtitle1" gutterBottom>
                    {address?.name + " " + address?.surname}
                  </Typography>
                  <Typography variant="body2">
                    {address?.country + " " + address?.city}
                  </Typography>
                  <Typography variant="body2">
                    {address?.street}
                  </Typography>
                </CardContent>
                <CardActions>
                <Button aria-label="Edit Item" onClick={() => openModalEditItem(address._id)}>
                  <EditIcon style={{color: '#EFA00B'}}/>
                </Button>
                <Button aria-label="Delete product" onClick={() => openDeleteModal()} size="small">
                <DeleteIcon style={{color: 'red'}}/>
                </Button>
                </CardActions>
              </div>
        </Card>
      </div>
      <EditDialog openEdit={openEdit} handleUpdateAddress={handleUpdateAddress} setOpenEdit={setOpenEdit} item={address} message={editItemMessage}>         
      </EditDialog>
      <ConfirmDialog open={open} handleDelete={handleDelete} setOpen={setOpen} item={address} message={message}></ConfirmDialog>
  </>
  )
}

export default Address